import React from "react";
import { profile } from "../../data/site";
import Reveal from "../chrome/Reveal";
import portrait from "../../assets/profile.jpg";

const About = () => (
  <section className="section" id="about">
    <div className="shell">
      <Reveal className="section__head">
        <span className="eyebrow">About</span>
        <h2 className="section__title">
          I build <span className="accent-text">the parts that have to work</span>
        </h2>
        <p className="section__lede">
          Backend, cloud and data by day; native mobile and front end when the product needs it.
        </p>
      </Reveal>

      <div className="about">
        <Reveal className="about__copy">
          {profile.bio.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </Reveal>

        <Reveal delay={80}>
          <figure className="portrait">
            <img
              src={portrait}
              alt="Ouri Alkada"
              width="640"
              height="800"
              loading="lazy"
              decoding="async"
            />
            <figcaption className="portrait__tag">
              <b>{profile.name}</b>
              {profile.location}
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
